import React from 'react'
import '../../_css/OurPlans.css'

const Card = ({
  plan,
  price,
  uploadsPerMonth,
  features = [],
  allFeatures = [],
  notes,
  color,
  isCurrentPlan = false,
  buttonType = 'Buy Now', // 'buy' or 'contact'
  priceText = '',
  handlePay = () => { },
  handleContact = () => { },
  isCustom = false,
  onceoffPaymentAmount = false,
}) => {
  const handleButtonClick = () => {
    if (buttonType === 'Buy Now') {
      // Handle buy now action
      handlePay(price)
    } else {
      // Handle contact action
      console.log('Contact clicked for:', plan)
    }
  }

  // Render feature item with checkmark or X mark
  const renderFeatureItem = (featureName) => {
    const isAvailable = features.includes(featureName.module)

    return (
      <div className='plan-feature-item' key={featureName.module}>
        <div className='plan-feature-row'>
          {isAvailable ? (
            <svg
              className='feature-icon feature-check'
              viewBox='0 0 20 20'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <circle cx='10' cy='10' r='10' className='icon-bg' />
              <path
                d='M6 10L9 13L14 7'
                stroke='currentColor'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
                fill='none'
              />
            </svg>
          ) : (
            <svg
              className={`feature-icon  ${isCustom ? 'feature-custom' : 'feature-cross'}`}
              viewBox='0 0 20 20'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <circle cx='10' cy='10' r='10' className='icon-bg' />
              <path
                d={isCustom ? 'M10 6V14M6 10H14' : 'M7 7L13 13M13 7L7 13'}
                stroke='currentColor'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          )}
          <span className='plan-feature-label'>{featureName.module_title}</span>
        </div>
      </div>
    )
  }

  // Render uploads per month info
  const renderUploadsInfo = () => {
    const isUnlimited = uploadsPerMonth == -1
    const displayValue = isUnlimited ? "Unlimited" : isCustom ? "Custom" : uploadsPerMonth

    return (
      <div className='uploads-info-container'>
        <span className='uploads-label'>Uploads per Month</span>
        <span className='uploads-value'>{displayValue}</span>
      </div>
    )
  }

  return (
    <div
      className={`plan-card ${isCurrentPlan ? 'current-plan' : ''}`}
      style={{ backgroundColor: color }}
    >
      {isCurrentPlan && (
        <div className='current-plan-badge'>Current Plan</div>
      )}
      <div className='plan-card-header'>
        <h3 className='plan-name'>{plan}</h3>
        <div className='plan-price-container'>
          {price > 0 && <div className='plan-price'>
            {onceoffPaymentAmount && <div>
              {Number(onceoffPaymentAmount) ? "R" : ""}{onceoffPaymentAmount}
              <span style={{ fontSize: '14px' }}>{" ("}Once Off{")"}</span>
            </div>}
            <div>
              {onceoffPaymentAmount && <span>+{" "}</span>}
              {Number(price) ? "R" : ""}{price}/
              <span style={{ fontSize: '14px' }}>month</span>
            </div>
          </div>}
          {/* <div className='plan-price-text'>{priceText}</div> */}
        </div>
      </div>
      <div className='plan-card-body'>
        {renderUploadsInfo()}
        {allFeatures.map((feature) => renderFeatureItem(feature))}
        <div className='plan-notes'>{notes}</div>
      </div>
      {plan != 'Trial' && !isCustom && <div className='plan-card-footer'>
        <button
          className={`plan-button buy-button`}
          onClick={handleButtonClick}
        >
          {buttonType}
        </button>
      </div>}

      {isCustom && <div className='plan-card-footer'>
        <button
          className={`plan-button contact-button`}
          onClick={handleContact}
        >
          Contact Us
        </button>
      </div>}
    </div>
  )
}

export default Card
